<div class="card">
  <img
    *ngIf="hasImage"
    onError="this.className='broken-image';"
    class="card-img-top"
    src="{{ image.url }}"
    alt="{{ image.title }}"
  />
  <div class="card-body">
    <h2 class="card-title">About Us</h2>
    <p class="card-text">
      Willand Garden Club has been meeting for over 80 years. We meet on the
      second Wednesday of each month (except January, February and August) in
      the Club Room at Willand Village Hall at 7.00pm. There are a variety of
      speakers talking about gardening and other topics of interest. Do please
      bring any plants you may wish to sell. We hold coffee mornings in the
      spring and autumn, usually have two outings, an annual club meal, and a
      bigger plant sale in May.
    </p>
    <p>
      No Flower Show will be held in 2024 but we hope a decision will be made
      regarding a one in 2025.
    </p>
    <p>
      At each monthly meeting we hold a raffle (donated prizes welcome); members
      are encouraged to bring a single flower of interest to be judged; plants
      for sale (75% returned to the grower, 25% for the Club) and refreshments.
      No Flower Show will be held in 2024 but we hope a decision will be made
      regarding a Flower show in 2025.
    </p>
    <p>
      The annual subscription is £5.00, visitors £1.00 per visit. The current
      membership card entitles you to 10% discount at The Old Well Garden
      Centre.
    </p>
  </div>
</div>
